export const videoData = {
  EN: {
    title: "Multimedia Hub",
    list: [
      { id: 1, title: "Pakistan takes centre stage as OIC Women’s Summit opens to advance empowerment agenda", thumb: "/OIC3.jpeg", src: "/Women.mp4" },
      { id: 2, title: "Pakistani Leaders Visited in Saudi Arabia", thumb: "/PS.jpeg", src: "/Video2.mp4" },
      { id: 3, title: "About TIENS Company", thumb: "/Tiens.jpeg", src: "/Video3.mp4" }
    ]
  },
  UR: {
    title: "ملٹی میڈیا ہب",
    list: [
      { id: 1, title: "پاکستان میں خواتین کی بااختیار بنانے کے ایجنڈے کو آگے بڑھانے کے لیے OIC ویمن سمٹ کا آغاز، پاکستان مرکزِ نگاہ۔", thumb: "/OIC3.jpeg", src: "/videos/Sports.mp4" },
      { id: 2, title: "پاکستانی رہنماؤں کے دورہ سعودی عرب کے حوالے سے اہم معلومات ", thumb: "/PS.jpeg", src: "/videos/Education.mp4" },
      { id: 3, title: "ٹائینز کے بارے میں", thumb: "/Tiens.jpeg", src: "/videos/Tech.mp4" }
    ]
  }
};


